import React, { useEffect, useRef } from "react";
import { getClassNameFactory } from "@dcl/ui";
import { default as FlexGrid } from "../../../../modules/FlexGrid";
import Button, { ButtonColor, ButtonKind, IconPosition } from "../../../../elements/Button";
import RefreshIcon from "../TableHeader/Icons/RefreshIcon";
import ErrorIcon from "../TableHeader/Icons/ErrorIcon";
import { default as Form } from "../../../../fragments/Form";
import { APPLY, CANCEL, CLEAR_FILTERS, FILTER_HEAD, FILTER_SUBHEAD, SELECT_ALL } from "./constants";
import { FocusScope } from "@react-aria/focus";

var TableFilter = function TableFilter(props) {
  var checkOptions = props.checkOptions,
      checkOptionsHanlder = props.checkOptionsHanlder,
      filterModalhandler = props.filterModalhandler,
      getFilterData = props.getFilterData,
      clearFilterData = props.clearFilterData,
      handleSelectAll = props.handleSelectAll,
      selectAllChecked = props.selectAllChecked,
      filterErrorState = props.filterErrorState;
  var getClassName = getClassNameFactory(TableFilter.displayName);
  var divRef = useRef(null);
  useEffect(function () {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(FocusScope, {
    contain: true,
    restoreFocus: true
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal"
    }),
    ref: divRef,
    role: "dialog",
    "aria-modal": true,
    "aria-label": "Show Filters",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal-content"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal-header"
    })
  }, /*#__PURE__*/React.createElement("p", null, FILTER_HEAD)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal-body"
    })
  }, /*#__PURE__*/React.createElement("p", null, FILTER_SUBHEAD)), filterErrorState.isError && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "error-body"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "error-icon"
    })
  }, ErrorIcon), /*#__PURE__*/React.createElement("p", {
    className: getClassName({
      descendantName: "error-msg"
    })
  }, filterErrorState.message)), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "list"
    })
  }, /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "select-all"
    })
  }, /*#__PURE__*/React.createElement(Form.CheckboxControl, {
    withOptionalLabel: false,
    id: "id-all",
    labelText: SELECT_ALL,
    name: SELECT_ALL,
    value: SELECT_ALL,
    checked: selectAllChecked,
    onChange: handleSelectAll
  })), checkOptions.map(function (option, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: getClassName({
        descendantName: "modal-selection"
      }),
      key: index
    }, /*#__PURE__*/React.createElement(Form.CheckboxControl, {
      id: option.id,
      labelText: option.title,
      name: option.title,
      withOptionalLabel: false,
      value: option.title,
      checked: option.isSelected,
      onChange: checkOptionsHanlder
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal-footer"
    })
  }, /*#__PURE__*/React.createElement(FlexGrid.Row, null, /*#__PURE__*/React.createElement(FlexGrid.Col, {
    md: 6,
    lg: 6,
    sm: 12
  }, /*#__PURE__*/React.createElement(Button, {
    kind: ButtonKind.BUTTON,
    color: ButtonColor.TERTIARY,
    disabled: false,
    onClick: clearFilterData,
    icon: RefreshIcon,
    iconPosition: IconPosition.LEFT
  }, CLEAR_FILTERS)), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    md: 3,
    lg: 3,
    sm: 12,
    className: getClassName({
      descendantName: "filter-buttons"
    })
  }, /*#__PURE__*/React.createElement(Button, {
    kind: ButtonKind.BUTTON,
    color: ButtonColor.SECONDARY,
    disabled: false,
    onClick: filterModalhandler
  }, CANCEL)), /*#__PURE__*/React.createElement(FlexGrid.Col, {
    md: 3,
    lg: 3,
    sm: 12
  }, /*#__PURE__*/React.createElement(Button, {
    kind: ButtonKind.BUTTON,
    color: ButtonColor.PRIMARY,
    disabled: false,
    onClick: getFilterData
  }, APPLY)))))));
};

TableFilter.displayName = "TableFilter";
export default TableFilter;